var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear factor de complejidad","back-to":"/complejidadesProyecto"}}),_c('formulario',{attrs:{"complejidad-proyecto":_vm.complejidadProyecto},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }